/* eslint-disable max-lines */
// Library methods

// Utils
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_FETCH_ENTITY,
    API_FETCH_ENTITY_V2,
    API_FORM_DETAILS,
    API_FORM_IN_PROCESS,
    API_ENTITY_LIST,
    API_ENTITY_LIST1,
    API_HIERARCHY_LIST,
    API_SAVE_CONTINUE,
    API_SUBMIT_FORM,
    API_ENTITY_CREATE,
    API_GET_PAYMENT_MODES,
    API_GET_DEFAULT_ROUTING,
    API_GET_SURCHARGE_SLABS,
    API_RETRY_FAILED_MERCHANT_FORM_BY_ID,
    API_FETCH_BASIC_DATA,
    API_SUBMIT_STEP_DETAILS,
    API_FETCH_BD_INPROGRESS_MERCHANT,
    API_ADD_BD_ONBOARDING_MAKER, API_FETCH_SURCHARGE_DETAILS,
} from '../../../utils/API/apiUrls';

// Common Constants
import {
    FORM_TYPE,
    SECTION_TYPE_TO_STEP_MAP,
} from '../../../utils/constants/commonValues';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as merchantAction from './merchantOnBoard.actions';

// Constants
import {
    FETCH_ENTITY_REQUEST,
    FETCH_FORM_DETAILS_REQUEST,
    FETCH_FORM_IN_PROCESS_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    FETCH_ENTITY_HIERARCHY_REQUEST,
    SAVE_AND_CONTINUE_REQUEST,
    CREATE_ENTITY_REQUEST,
    FETCH_PAYMENT_MODES_REQUEST,
    FETCH_SURCHARGE_SLABS_REQUEST,
    FETCH_DEFAULT_ROUTING_REQUEST,
    SET_UNIQUE_IDENTIFIER_REQUEST,
    FETCH_ENTITY_HIERARCHY_MLE_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_MLE_REQUEST,
    SUBMIT_FORM_REQUEST,
    RETRY_FAILED_MERCHANT_FORM_REQUEST,
    SUBMIT_STEP_FORM_REQUEST,
    FETCH_BD_INPROGRESS_MERCHANT_REQUEST,
} from './merchantOnBoard.constants';
import { toast } from 'react-toastify';
import moment from 'moment';
import { takeLatest, takeEvery, put, call } from 'redux-saga/effects';
import { fetchEntityListSuccessAddList } from './merchantOnBoard.actions';

import API_GET_SURCHARGE_SLABS_MOCK from "./API_GET_SURCHARGE_SLABS_MOCK.json";
import API_FETCH_BASIC_DATA_MOCK from "./API_FETCH_BASIC_DATA_MOCK.json";
import API_FETCH_SURCHARGE_DETAILS_MOCK from './API_FETCH_SURCHARGE_DETAILS.json';

const getRequestData = payload => {
    const request = {
        pageNumber: 1,
        pageSize: 10,
        sort: 'createdOn',
        status: "ACTIVE",
        entityType: 'MERCHANT',
        enterpriseMerchant: true,
    };

    if (payload.pageIndex) {
        request.pageNumber = payload.pageIndex;
    }
    if (payload.pageSize) {
        request.pageSize = payload.pageSize;
    }
    if (payload.axisMid) {
        request.axisMid = payload.axisMid;
    }
    if (payload.createdBy) {
        request.createdBy = payload.createdBy;
    }
    if (payload.createdOn) {
        const { startDate, endDate } = payload.createdOn;
        request.createdOn = `btn:${moment(startDate).format(
            'YYYY-MM-DD'
        )},${moment(endDate).format('YYYY-MM-DD')}`;
    }
    if (payload.mode) {
        request.mode = payload.mode;
    }
    if (payload.status || payload.status === 0) {
        request.status = payload.status;
    }
    if (payload.merchantId) {
        request.merchantId = payload.merchantId;
        delete request.status;
    }
    return request;
};

export function* fetchEntity(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestData(payload);
        const { data } = yield call(POST, API_FETCH_ENTITY_V2, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.fetchEntitySuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchEntityError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(merchantAction.fetchEntityError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchFormDetails() {
    yield put(loaderActions.showLoader());
    try {
        const request = {
            formType: FORM_TYPE.MERCHANT_ON_BOARD,
        };
        const { data } = yield call(POST, API_FORM_DETAILS, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.fetchFormDetailsSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchFormDetailsError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(merchantAction.fetchFormDetailsError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchFormInProcessDetails() {
    yield put(loaderActions.showLoader());
    try {
        const request = {
            formType: FORM_TYPE.MERCHANT_ON_BOARD,
        };
        const { data } = yield call(POST, API_FORM_IN_PROCESS, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.fetchFormInProcessSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchFormInProcessError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(merchantAction.fetchFormInProcessError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchEntityListDetails(actions) {
    yield put(merchantAction.showHierarchyLoader());
    try {
        const { payload, entityData } = actions;
        console.log(entityData, "entityData");
        const request = {
            entityType: payload && payload.toUpperCase(),
            entityName: entityData ? entityData.entityName : '',
            entityCode: entityData ? entityData.entityCode : '',
            paging: {
                pageNumber: 1,
                pageSize: 500,
            },
        };
        const { data } = yield call(POST, API_ENTITY_LIST1, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            const values = {};
            values[payload.toLowerCase()] = data && data.entities;

            if(entityData){
                yield put(merchantAction.fetchEntityListSuccessAddList(values, payload.toLowerCase()));
            }else {
                yield put(merchantAction.fetchEntityListSuccess(values));
            }
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchEntityListError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.fetchEntityListError({ error: data }));
    }
    yield put(merchantAction.hideHierarchyLoader());
}

export function* fetchHierarchyDetails(actions) {
    yield put(merchantAction.showHierarchyLoader());
    try {
        const { payload, level, entityType, onSuccess } = actions;
        const request = {
            entityCode: payload,
            entityLevel: level,
        };
        const { data } = yield call(POST, API_HIERARCHY_LIST, request);

        console.log(data, "DATA_DATA");

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                merchantAction.fetchEntityHierarchySuccess(data, entityType)
            );
            if (onSuccess) {
                onSuccess();
            }
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchEntityHierarchyError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.fetchEntityHierarchyError({ error: data }));
    }
    yield put(merchantAction.hideHierarchyLoader());
}

export function* saveAndContinueDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType, makerDetails, customisedReports } = actions;
        const modifiedPayload = {...payload, data:{...payload.data, customisedReports}}
        const request = {
            ...modifiedPayload,
            formType: FORM_TYPE.MERCHANT_ON_BOARD,
        };
        const { data } = yield call(POST, API_SAVE_CONTINUE, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            if (sectionType === 'notificationSection') {
                const makerRequest = {
                    ...makerDetails,
                    request: JSON.stringify(data),
                };

                try {
                    const { data: makerRequestResponse } = yield call(
                        POST,
                        API_ADD_BD_ONBOARDING_MAKER('merchant'),
                        makerRequest
                    );

                    if (
                        makerRequestResponse &&
                        makerRequestResponse.statusCode ===
                            apiStatusCodes.SUCCESS
                    ) {
                        yield put(
                            merchantAction.saveAndContinueSuccess(
                                data,
                                sectionType,
                            )
                        );
                    } else if (data && data.errorMessage) {
                        yield put(
                            merchantAction.saveAndContinueError({
                                error: data,
                            })
                        );
                    }
                } catch (error) {
                    const errorData = error.response && error.response.data;
                    yield put(
                        merchantAction.saveAndContinueError({ error: errorData })
                    );
                }
            } else {
                yield put(
                    merchantAction.saveAndContinueSuccess(data, sectionType, customisedReports)
                );
            }
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.saveAndContinueError({
                    error: data,
                })
            );
        }
    } catch (error) {
        const errorData = error.response && error.response.data;
        yield put(merchantAction.saveAndContinueError({ error: errorData }));
    }
    yield put(loaderActions.hideLoader());
}

export function* createEntityDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_ENTITY_CREATE, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.createEntitySuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.createEntityError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.createEntityError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* getPaymentModes() {
    yield put(loaderActions.showLoader());
    try {
        const request = {};
        const { data } = yield call(POST, API_GET_PAYMENT_MODES, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.fetchPaymentModesSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchPaymentModesError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.fetchPaymentModesError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* getSurchargeSlabs(action) {
    yield put(loaderActions.showLoader());
    try {
        if (!action.payload) {
            let data = {};

            if (process.env.REACT_APP_IS_ODS_MOCK === 'true') {
                data = API_GET_SURCHARGE_SLABS_MOCK;
            } else {
                const res =  yield call(POST, API_GET_SURCHARGE_SLABS, {});
                data = res.data;
            }

            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                yield put(merchantAction.fetchSurchargeSlabsSuccess(data));
            } else if (data && data.errorMessage) {
                yield put(
                    merchantAction.fetchSurchargeSlabsError({
                        error: data,
                    })
                );
            }
        } else {
            const request = action.payload;
            let data = {};
            let nbOptions = {};

            if (process.env.REACT_APP_IS_ODS_MOCK === 'true') {
                data = API_FETCH_BASIC_DATA_MOCK;
                nbOptions = API_GET_SURCHARGE_SLABS_MOCK;
            } else {
                const res =  yield call(POST, API_FETCH_BASIC_DATA, request);
                data = res.data;

                const nbRes =  yield call(
                    POST,
                    API_GET_SURCHARGE_SLABS,
                    {}
                );
                nbOptions = nbRes.data;
            }

            if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
                data.paymentOptionList = nbOptions?.paymentOptionList;
                yield put(merchantAction.fetchSurchargeSlabsSuccess(data));
            } else if (data && data.errorMessage) {
                yield put(
                    merchantAction.fetchSurchargeSlabsError({
                        error: data,
                    })
                );
            }
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.fetchSurchargeSlabsError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* getDefaultRouting(action) {
    yield put(loaderActions.showLoader());
    try {
        const request = action.payload;
        const { data } = yield call(POST, API_GET_DEFAULT_ROUTING, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.fetchDefaultRoutingSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchDefaultRoutingError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.fetchDefaultRoutingError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* setUniqueIdentifer(actions) {
    try {
        const { payload, isEditMode } = actions;
        yield put(
            merchantAction.setUniqueIdentifierSuccess(payload, isEditMode)
        );
    } catch (exception) {
        yield put(
            merchantAction.setUniqueIdentifierError({
                error: 'Unable to set unique identifier',
            })
        );
    }
}

export function* fetchHierarchyMLEDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, entityType } = actions;
        const request = {
            entityCode: payload,
            entityLevel: 'LOWER_COMPLETE',
        };
        const { data } = yield call(POST, API_HIERARCHY_LIST, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                merchantAction.fetchEntityHierarchyMLESuccess(data, entityType)
            );
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchEntityHierarchyMLEError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.fetchEntityHierarchyMLEError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchEntityListMLEDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            entityType: payload && payload.toUpperCase(),
        };
        const { data } = yield call(POST, API_ENTITY_LIST, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            const values = {};
            values[payload.toLowerCase()] = data && data.entities;
            yield put(merchantAction.fetchEntityListMLESuccess(values));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchEntityListMLEError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.fetchEntityListMLEError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* submitDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = payload;
        request.formType = FORM_TYPE.MERCHANT_ON_BOARD;
        const { data } = yield call(POST, API_SUBMIT_FORM, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.submitFormSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.submitFormError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        const errorMessage =
            data.errorMessage ||
            'Unable to process the request. Please Try Again';
        toast.info(errorMessage);
        // yield put(merchantAction.submitFormError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* retryFailedMerchantForm(actions) {
    yield put(merchantAction.showLoader());
    try {
        const { payload } = actions;
        const request = payload;
        const { data } = yield call(
            POST,
            API_RETRY_FAILED_MERCHANT_FORM_BY_ID,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.retryFailedMerchantFormSuccess(data));

            toast.info('Form resubmitted successfully');
        } else if (data && data.errorMessage) {
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(merchantAction.retryFailedMerchantFormError({ error: data }));
        toast.info(
            data.errorMessage ||
                'Unable to process request. Please try again later'
        );
    }
    yield put(merchantAction.hideLoader());
}

export function* submitStepFormDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType } = actions;
        const request = payload;
        request.formType = FORM_TYPE.MERCHANT_ON_BOARD;

        const { data } = yield call(
            POST,
            API_SUBMIT_STEP_DETAILS(
                SECTION_TYPE_TO_STEP_MAP[payload.sectionType]
            ),
            request
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                merchantAction.submitStepFormSuccess(data, payload.sectionType)
            );
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.submitStepFormError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(merchantAction.submitStepFormError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchBDInProgressMerchants(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestData(payload);
        const { data } = yield call(
            POST,
            API_FETCH_BD_INPROGRESS_MERCHANT,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantAction.fetchBDInprogressMerchantSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantAction.fetchBDInprogressMerchantError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            merchantAction.fetchBDInprogressMerchantError({ error: data })
        );
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* merchantSagas() {
    yield takeLatest(FETCH_ENTITY_REQUEST, fetchEntity);
    yield takeLatest(FETCH_FORM_DETAILS_REQUEST, fetchFormDetails);
    yield takeLatest(FETCH_FORM_IN_PROCESS_REQUEST, fetchFormInProcessDetails);
    yield takeEvery(FETCH_ENTITY_LIST_MERCHANT_REQUEST, fetchEntityListDetails);
    yield takeEvery(FETCH_ENTITY_HIERARCHY_REQUEST, fetchHierarchyDetails);
    yield takeLatest(SAVE_AND_CONTINUE_REQUEST, saveAndContinueDetails);
    yield takeLatest(CREATE_ENTITY_REQUEST, createEntityDetails);
    yield takeLatest(FETCH_PAYMENT_MODES_REQUEST, getPaymentModes);
    yield takeLatest(FETCH_SURCHARGE_SLABS_REQUEST, getSurchargeSlabs);
    yield takeLatest(FETCH_DEFAULT_ROUTING_REQUEST, getDefaultRouting);
    yield takeLatest(SET_UNIQUE_IDENTIFIER_REQUEST, setUniqueIdentifer);
    yield takeLatest(
        FETCH_ENTITY_HIERARCHY_MLE_REQUEST,
        fetchHierarchyMLEDetails
    );
    yield takeLatest(
        FETCH_ENTITY_LIST_MERCHANT_MLE_REQUEST,
        fetchEntityListMLEDetails
    );
    yield takeLatest(SUBMIT_FORM_REQUEST, submitDetails);
    yield takeLatest(
        RETRY_FAILED_MERCHANT_FORM_REQUEST,
        retryFailedMerchantForm
    );
    yield takeLatest(SUBMIT_STEP_FORM_REQUEST, submitStepFormDetails);
    yield takeLatest(
        FETCH_BD_INPROGRESS_MERCHANT_REQUEST,
        fetchBDInProgressMerchants
    );
}
